var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6875 -0.000976562C0.75552 -0.000976562 0 0.754543 0 1.68652V14.624C0 15.2453 0.50368 15.749 1.125 15.749V1.68652C1.125 1.37586 1.37684 1.12402 1.6875 1.12402H15.75C15.75 0.502703 15.2463 -0.000976562 14.625 -0.000976562H1.6875Z",
    fill: "#3A83F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 2.24902C3.00552 2.24902 2.25 3.00454 2.25 3.93652V16.3115C2.25 17.2435 3.00552 17.999 3.9375 17.999H10.784C11.2316 17.999 11.6608 17.8212 11.9773 17.5048L17.5057 11.9763C17.8222 11.6598 18 11.2306 18 10.783V3.93652C18 3.00454 17.2445 2.24902 16.3125 2.24902H3.9375ZM3.375 3.93652C3.375 3.62586 3.62684 3.37402 3.9375 3.37402H16.3125C16.6232 3.37402 16.875 3.62586 16.875 3.93652V10.124H11.8125C10.8805 10.124 10.125 10.8795 10.125 11.8115V16.874H3.9375C3.62684 16.874 3.375 16.6222 3.375 16.3115V3.93652ZM11.25 16.641V11.8115C11.25 11.5009 11.5018 11.249 11.8125 11.249H16.642L11.25 16.641Z",
    fill: "#3A83F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.d294f75f12bf7f1e1541e91bfd992087.svg";
export { ForwardRef as ReactComponent };